module.exports = __webpack_public_path__ + "img/upload_file.f0366457.svg";